import { Route } from "wouter";
import { getPhases } from "./registry.js";
import { HelmLayout } from "./layouts.js";

export const PhaseRoutes = () => {
  const phases = getPhases();

  return (
    <>
      {phases.map(phase => (
        <Route key={phase.type} path={`/o/:orgSlug/${phase.type}`}>
          <HelmLayout>
            <phase.page />
          </HelmLayout>
        </Route>
      ))}
    </>
  );
};
